import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_authenticated/_layout/tasks/')({
  component: Tasks,
});

function Tasks() {
  const navigate = useNavigate({ from: '/tasks' });

  useEffect(() => {
    navigate({ to: '/tasks/new' });
  }, []);

  return (
    <div className='flex flex-col h-full'>
      <div className='flex-1 space-y-8 py-4'>
        <Outlet />
      </div>
    </div>
  );
}
